<template>
  <div>
    <vs-button icon-pack="feather" icon="icon icon-file" @click="add">Novo</vs-button>

    <div class="data-list-container mt-5">
      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        @selected="handleClick"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>TITULO</vs-th>
          <vs-th>TIPO</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>ORDEM</vs-th>
          <vs-th>DATA DE INÍCIO</vs-th>
          <vs-th>DATA DE FIM</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].title">
              <router-link :to="{ name: 'banner-detalhes', params: { id: data[idx].id } }">{{data[idx].title}}</router-link>
            </vs-td>
            <vs-td :data="data[idx].type">{{data[idx].type | deviceType}}</vs-td>
            <vs-td :data="data[idx].status">{{data[idx].status | status}}</vs-td>
            <vs-td :data="data[idx].sort">{{data[idx].sort}}</vs-td>
            <vs-td :data="data[idx].date_start">{{data[idx].date_start | formatDate}}</vs-td>
            <vs-td :data="data[idx].date_end">{{data[idx].date_end | formatDate}}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      timeout: null
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.$vs.loading();

      this.$api
        .get('/api/v1/backend/banners')
        .then(response => {
          this.$vs.loading.close();
          this.data = response.data.data;
        });
    },
    add() {
      this.$router.push({ name: 'banner-detalhes' });
    },
    handleClick(row) {
      this.$router.push({ name: 'banner-detalhes', params: { id: row.id } });
    }
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
